
const requireComponent = require.context(
  '@/components/common',
  true,
  /(.vue)$/
);
const results = requireComponent.keys().filter((item) => item);

export default {
  requireComponent,
  results,
};
